import { ProductDetails, isDiscontedPrice } from '@models';

// Prices are loaded in Shopping Dollars, so the price itself is the Shopping Dollar amount.
export const addToCartMessage = (product: ProductDetails, rewardName: string): string => {
  const isDiscountAvailable = isDiscontedPrice(product);
  const price = Math.trunc(isDiscountAvailable ? product.discountedPrice : product.price);

  return `Add to cart ${product.name} with ${isDiscountAvailable ? 'discount' : ''} price ${price} ${rewardName}`;
};
